import { Checkbox, Dialogs, Pane, Flex, Text } from '@leverege/ui-elements';
import React, { useCallback, useMemo } from 'react';
import DeviceInput from '../../pairing/DeviceInput';
import SalesFlowTagSearch from './SalesFlowTagSearch';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function RecovrKeyListItem(props) {
  const {
    actions,
    tagBlueprint,
    location,
    data: key,
    saleData,
    onChange: pOnChange,
    knowTags
  } = props;
  const onChange = useCallback(evt => {
    if (typeof evt.data === 'string') {
      pOnChange({
        data: key.id,
        value: {
          ...saleData,
          [evt.data]: evt.value
        }
      });
    } else {
      pOnChange({
        data: key.id,
        value: {
          ...saleData,
          ...Object.keys(evt.data).reduce((prev, curr) => {
            prev[curr] = evt.value[curr];
            return prev;
          }, {})
        }
      });
    }
  }, [pOnChange, saleData, key.id]);
  const openSearch = useCallback(() => {
    Dialogs.show({
      id: 'salesFlowTagSearch',
      component: SalesFlowTagSearch,
      props: {
        actions,
        tagBlueprint,
        location,
        eventData: 'tagId',
        value: key.data?.tag?.data?.serialNumber,
        onChange,
        knowTags
      }
    });
  }, [actions, location, tagBlueprint, onChange, key]);
  const pairingMessage = useMemo(() => {
    if (saleData.sell || saleData.targetScreen === 'addAdditionalTagsToSale') {
      if (saleData.tagId) {
        return /*#__PURE__*/_jsx(Text, {
          variant: "body",
          children: "Verify the ID on the back of the RecovR Tag"
        });
      }
      return /*#__PURE__*/_jsx(Text, {
        variant: "body",
        children: "Please select a RecovR Tag"
      });
    }
    if (key.data?.tag) {
      return /*#__PURE__*/_jsxs(Text, {
        style: {
          alignItems: 'baseline'
        },
        variant: "warning",
        icon: "fa fa-fw fa-solid fa-circle-exclamation",
        iconOpts: {
          style: {
            color: 'var(--color-warning500)'
          }
        },
        children: [/*#__PURE__*/_jsx("b", {
          children: "Reminder:"
        }), " Remove tag ", key.data.tag.serialNumber, " from the key before completing the sale."]
      });
    }
    return 'This key will be sold without a tag';
  }, [saleData, key]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Pane, {
      variant: "keyListItemTop",
      children: /*#__PURE__*/_jsx(Checkbox, {
        eventData: "sell",
        onChange: onChange,
        value: saleData?.sell,
        variant: "locatorReplacement|keyListItem",
        label: "Sell RecovR Tag with Key:",
        help: `${key.data?.notes ?? ''}${key.data?.keyId ? `, ${key.data.keyId}` : ''}`
      })
    }), /*#__PURE__*/_jsx(Pane, {
      variant: "keyListItemBottom",
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsx(DeviceInput, {
          "data-test-postfix": "SalesFlowTag",
          eventData: "tagId",
          onClick: openSearch,
          onFocus: openSearch,
          value: saleData.tagId
        }), pairingMessage]
      })
    })]
  });
}